import { makeStyles } from "@mui/styles";

const styles = makeStyles((theme) => ({
  divider: {
    margin: "16px 0 !important",
  },
  container: {
    display: "flex",
    justifyContent: "space-between",
  },
  row: {
    width: "100%",
    margin: "16px 0",
  },
}));

export default styles;
